import React, { useState } from 'react';
import { generateAssignmentAiSummaries } from '../../../../../core/api';
import s from './GenerateAiSummariesButton.module.css';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const GenerateAiSummariesButton = ({ courseId, assignmentId }) => {
  const [generatingAiSummaries, setGeneratingAiSummaries] = useState(false);
  const user = useSelector((state) => state.user);
  const userCanGenerateAiSummaries = user?.app_metadata?.admin;

  const handleGenerateSummariesClick = async () => {
    try {
      setGeneratingAiSummaries(true);
      await generateAssignmentAiSummaries(courseId, assignmentId);
    } finally {
      setGeneratingAiSummaries(false);
    }
  };

  return (
    <>
      {userCanGenerateAiSummaries && (
        <button
          className={s.button}
          onClick={handleGenerateSummariesClick}
          data-test-id="Insights_grs_summaries_regenerate_summaries_btn"
          disabled={generatingAiSummaries}
        >
          <span
            className={
              generatingAiSummaries
                ? s.regenerateIconSpinning
                : s.regenerateIcon
            }
          >
            &#x21BB;
          </span>
          Regenerate Summaries
        </button>
      )}
    </>
  );
};

GenerateAiSummariesButton.propTypes = {
  courseId: PropTypes.string.isRequired,
  assignmentId: PropTypes.string.isRequired,
};
